import { TenantDto } from '../../models';

export interface TenantState {
  currentTenant: TenantDto | null;
  loading: boolean;
  error: string | null;
}

export const initialTenantState: TenantState = {
  currentTenant: null,
  loading: false,
  error: null,
};
